<div class="container">
    <h2 class="title">Liste des chaines</h2>
    <div class="horizontal-separator"></div>
    <div class="dialog-body">
        <div *ngFor="let channel of data">
            <mat-checkbox class="tv-ns-blue-checkbox" [(ngModel)]="channel.SELECTED" [disabled]="channel.DISABLED">{{
                channel.NOMCHANNEL
            }}</mat-checkbox>
        </div>
    </div>
    <div class="action-button">
        <button mat-button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelClick()">Annuler</button>
        <button mat-button class="tv-ns-validation-large-button left-margin-20" [mat-dialog-close]="data">Valider</button>
    </div>
</div>
